import React from 'react';
import PropTypes from 'prop-types';
import { CircleImageTitle } from '../circleImageTitle';
import './playlistItem.css';
import moment from 'moment';
import { parsePlaylistItem, getProp } from './../../../ui/src/utilities.js';
import noImg from './../../../assets/no-image-small.png';
import cx from 'classnames';

const PlaylistItem = (props) => {
  let [title, subtitle] = parsePlaylistItem(props.item.title);
  const isYoutube = getProp(props.item, 'youtube.url') ? true : false;
  let img = getProp(props.item, 'thumbnail', null);
  if (img === null) {
    img = noImg;
  }

  return (
    <div
      className={cx('playlist-item', { curp: isYoutube })}
      onClick={
        isYoutube
          ? () => {
              if (window && window.ga) {
                window.ga(
                  'send',
                  'event',
                  'playlist',
                  'play',
                  props.item.title,
                );
              }
              props.onClickYoutube(
                Object.assign({}, getProp(props.item, 'youtube', {}), {
                  title: props.item.title,
                }),
              );
            }
          : null
      }
    >
      <CircleImageTitle
        image={img}
        title={<strong className="text-uppercase">{title}</strong>}
        subtitle={subtitle}
        time={
          props.active ? 'Teraz' : moment(props.item.datetime).format('HH:mm')
        }
        playable={isYoutube}
        active={props.active}
      />
    </div>
  );
};

PlaylistItem.defaultProps = {
  item: {},
  active: false,
};

PlaylistItem.propTypes = {
  item: PropTypes.object.isRequired,
  active: PropTypes.bool,
  onClickYoutube: PropTypes.func.isRequired,
};

export default PlaylistItem;



// WEBPACK FOOTER //
// ./src/app/component/playlistItem/playlistItem.js